import { useParams } from "react-router";
import ButtonGroup from "../../components/ButtonGroup";
import Panel from "../../components/Panel";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useBike, useUpdateBike } from "../../hooks/useBikes";
import { Fork as ForkAPI } from "../../http/onlyclicksApi";
import { translate } from "../../i18n";
import { Language } from "../../types";
import Description, { DescriptionList } from "../Profile/Description";

const Fork = () => {
  const i18n = translate(Language.English);
  const params = useParams<"bikeId">();
  const bikeId = String(params.bikeId);
  const { data: bike, isSuccess } = useBike(bikeId);
  const mutation = useUpdateBike();

  const mutateFork = (fork: ForkAPI) => {
    if (!bike) return;

    return mutation.mutate({
      id: bike.id,
      bike: {
        name: bike.name,
        show_wheels: bike.show_wheels,
        fork: fork,
        shock: bike.shock,
      },
    });
  };

  return (
    <Panel>
      {isSuccess && bike.fork !== undefined && (
        <DescriptionList>
          <Description
            label="Suspension Type"
            value={
              <ButtonGroup>
                <ButtonGroup.Button
                  isActive={bike.fork.type === "air"}
                  onClick={() =>
                    mutateFork({
                      ...bike.fork!,
                      type: "air",
                    })
                  }
                >
                  Air
                </ButtonGroup.Button>
                <ButtonGroup.Button
                  isActive={bike.fork.type === "coil"}
                  onClick={() =>
                    mutateFork({
                      ...bike.fork!,
                      type: "coil",
                      show_volume_spacers: false,
                    })
                  }
                >
                  Coil
                </ButtonGroup.Button>
              </ButtonGroup>
            }
          />
          <Description
            label={i18n.sag}
            value={
              <ToggleSwitch
                checked={bike.fork.show_sag}
                onChange={(b) =>
                  mutateFork({
                    ...bike.fork!,
                    show_sag: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.lsc(false)}
            value={
              <ToggleSwitch
                checked={bike.fork.show_lsc}
                onChange={(b) =>
                  mutateFork({
                    ...bike.fork!,
                    show_lsc: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.hsc(false)}
            value={
              <ToggleSwitch
                checked={bike.fork.show_hsc}
                onChange={(b) =>
                  mutateFork({
                    ...bike.fork!,
                    show_hsc: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.lsr(true, false)}
            value={
              <ToggleSwitch
                checked={bike.fork.show_lsr}
                onChange={(b) =>
                  mutateFork({
                    ...bike.fork!,
                    show_lsr: b,
                  })
                }
              />
            }
          />
          <Description
            label={i18n.hsr(false)}
            value={
              <ToggleSwitch
                checked={bike.fork.show_hsr}
                onChange={(b) =>
                  mutateFork({
                    ...bike.fork!,
                    show_hsr: b,
                  })
                }
              />
            }
          />
          {bike.fork.type === "air" && (
            <>
              <Description
                label={i18n.volume_spacers}
                value={
                  <ToggleSwitch
                    checked={bike.fork.show_volume_spacers}
                    onChange={(b) =>
                      mutateFork({
                        ...bike.fork!,
                        show_volume_spacers: b,
                      })
                    }
                  />
                }
              />
              <Description
                label={i18n.negative_air_pressure(false)}
                value={
                  <ToggleSwitch
                    checked={bike.fork.show_negative_psi}
                    onChange={(b) =>
                      mutateFork({
                        ...bike.fork!,
                        show_negative_psi: b,
                      })
                    }
                  />
                }
              />
            </>
          )}
        </DescriptionList>
      )}
    </Panel>
  );
};

export default Fork;
